<!-- eslint-disable max-len -->
<template>
  <v-stepper-content step="1" :class="$vuetify.breakpoint.name === 'xs' ? 'px-0' : ''">
    <v-dialog
      v-model="uploadDialog"
      max-width="600px"
      persistent
    >
      <DocumentsDesktop
        v-bind:categoryTitle="categoryTitle"
        v-bind:categoryDescription="categoryDescription"
        v-bind:category="categoryKey"
        v-bind:type="categoryType"
        v-bind:files="documents"
        v-on:setDialog="uploadDialog = $event"
      ></DocumentsDesktop>
    </v-dialog>
    <v-col
      cols="12"
      :class="$vuetify.breakpoint.name !== 'sm' ? 'd-flex justify-center mx-0 px-0' : 'd-flex justify-center'"
    >
      <v-card
        flat
        outlined
        rounded="lg"
        :max-width="$vuetify.breakpoint.name === 'xs' ? '95vw' : '75vw'"
        min-height="500px"
      >
      <v-row :class="$vuetify.breakpoint.name === 'xs' ? 'mt-8 mx-1' : 'mt-8 mx-5'">
          <v-col
            cols="12"
            class="d-flex justify-center"
          >
            <div class="text-md-body-1 text-body-2 font-weight-medium">Our goal is to prepare a comprehensive human resources strategy that accurately reflects your business and its needs. In order to do so, we’ll need to gather some information.</div>
          </v-col>

          <!-- Health Insurance -->
          <v-col
            cols="12"
            class="mt-5"
          >
            <div class="text-md-body-1 text-body-2">*Are you interested in receiving a Benefits quote (health insurance)?</div>
          </v-col>
          <v-col cols="12" class="pt-0">
            <v-radio-group
              v-model="hasBenefitPacket"
              row
              class="mt-0"
              mandatory

            >
                <v-radio
                  label="Yes"
                  :value="true"
                  @click="showBenefitsTutorial"
                ></v-radio>
                <v-radio
                  label="No"
                  :value="false"
                ></v-radio>
            </v-radio-group>
          </v-col>

          <!-- PEO -->
          <v-col
            cols="12"
            class="mt-5"
          >
            <div class="text-md-body-1 text-body-2">*Are you currently working with another PEO firm?</div>
          </v-col>
          <v-col cols="12" class="pt-0">
            <v-radio-group
              v-model="peoChoice"
              mandatory
              row
              class="mt-0"
            >
                <v-radio
                  label="Yes"
                  :value="true"
                ></v-radio>
                <v-radio
                  label="No"
                  :value="false"
                ></v-radio>
            </v-radio-group>
          </v-col>

          <!-- PEO Company Name -->
          <v-col cols="12" sm="6" v-if="peoChoice === true">
            <v-text-field
              outlined
              label="PEO Company Name"
              class="rounded-lg"
              hide-details
              v-model="peoName"
            ></v-text-field>
          </v-col>

          <!-- PEO Effective Data -->
          <v-col cols="12" sm="6" v-if="peoChoice === true">
            <v-menu
              ref="peoDateMenuStep1"
              v-model="peoDateMenuStep1"
              :close-on-content-click="false"
              :return-value.sync="peoDate"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="peoDate"
                  outlined
                  label="PEO Effective Date"
                  class="rounded-lg"
                  hide-details
                  append-icon="mdi-calendar"
                  v-bind="attrs"
                  v-on="on"
                  readonly
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="peoDate"
                scrollable
              >
                <v-spacer></v-spacer>
                <v-btn
                  text
                  color="primary"
                  @click="peoDateMenuStep1 = false"
                >
                  Cancel
                </v-btn>
                <v-btn
                  text
                  color="primary"
                  @click="$refs.peoDateMenuStep1.save(peoDate)"
                >
                  OK
                </v-btn>
              </v-date-picker>
            </v-menu>
          </v-col>

          <!-- Documents -->
          <v-col
            cols="12"
            class="mt-5"
          >
            <div class="text-md-body-1 text-body-2">Please take some time to upload the following documents:</div>
            <v-list class="mt-3" id="intro">
              <!-- Button1 / Declaration -->
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title style="white-space: normal;">Declaration page of your Workers' Compensation policy</v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                  <v-btn
                    color="secondary"
                    outlined
                    @click="setWorkersCompensation"
                  >
                    Upload
                  </v-btn>
                  <v-list-item-action-text
                    v-for="(item, index) in workersCompensation"
                    :key="index"
                  >
                    {{ item.name }}
                  </v-list-item-action-text>
                </v-list-item-action>
              </v-list-item>
              <!-- Button2 / Comp Policy Invoice -->
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title style="white-space: normal;">Latest Workers' Compensation policy invoice</v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                  <v-btn
                    color="secondary"
                    outlined
                    @click="setWorkersCompensationPolicyInvoice"
                  >
                    Upload
                  </v-btn>
                  <v-list-item-action-text
                    v-for="(item, index) in workersCompensationPolicyInvoice"
                    :key="index"
                  >
                    {{ item.name }}
                  </v-list-item-action-text>
                </v-list-item-action>
              </v-list-item>
              <!-- Button3 / Recent payroll -->
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title style="white-space: normal;">Copy of your most recent payroll register</v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                  <v-btn
                    color="secondary"
                    outlined
                    @click="setPayrollRegister"
                  >
                    Upload
                  </v-btn>
                  <v-list-item-action-text
                    v-for="(item, index) in payrollRegister"
                    :key="index"
                  >
                    {{ item.name }}
                  </v-list-item-action-text>
                </v-list-item-action>
              </v-list-item>
              <!-- Button4 / State Unemployment Report -->
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title style="white-space: normal;">Latest quarterly State Unemployment report</v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                  <v-btn
                    color="secondary"
                    outlined
                    @click="setUnemploymentReport"
                  >
                    Upload
                  </v-btn>
                  <v-list-item-action-text
                    v-for="(item, index) in unemploymentReport"
                    :key="index"
                  >
                    {{ item.name }}
                  </v-list-item-action-text>
                </v-list-item-action>
              </v-list-item>
              <!-- Button5 / Worker Comp loss repot -->
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title style="white-space: normal;">Workers' Compensation loss reports from last 5 years</v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                  <v-btn
                    color="secondary"
                    outlined
                    @click="setWorkersCompLossReport"
                  >
                    Upload
                  </v-btn>
                  <v-list-item-action-text
                    v-for="(item, index) in workersCompLossReport"
                    :key="index"
                  >
                    {{ item.name }}
                  </v-list-item-action-text>
                </v-list-item-action>
              </v-list-item>
            </v-list>
          </v-col>
          <BtnContinue />
        </v-row>
      </v-card>
    </v-col>
  </v-stepper-content>
</template>

<script>
import { ref } from 'vue';
import BtnContinue from '../../btnContinue.vue';
import DocumentsDesktop from '../DocumentsDesktop.vue';

export default {
  name: 'StepOne',
  components: {
    BtnContinue,
    DocumentsDesktop,
  },
  data: () => ({
    peoDateMenuStep1: false,
    uploadDialog: false,
    categoryTitle: '',
    categoryDescription: '',
    categoryKey: '',
    categoryType: 'Prospect',
  }),
  computed: {
    documents() {
      let files = null;
      switch (this.categoryKey) {
        case 'WorkersCompensation':
          files = ref(this.workersCompensation);
          break;
        case 'WorkersCompensationPolicyInvoice':
          files = ref(this.workersCompensationPolicyInvoice);
          break;
        case 'PayrollRegister':
          files = ref(this.payrollRegister);
          break;
        case 'UnemploymentReport':
          files = ref(this.unemploymentReport);
          break;
        case 'WorkersCompLossReport':
          files = ref(this.workersCompLossReport);
          break;
        default:
          files = null;
          break;
      }
      return files;
    },
    workersCompensation() {
      return this.filterProspectDocuments('WorkersCompensation');
    },
    workersCompensationPolicyInvoice() {
      return this.filterProspectDocuments('WorkersCompensationPolicyInvoice');
    },
    payrollRegister() {
      return this.filterProspectDocuments('PayrollRegister');
    },
    unemploymentReport() {
      return this.filterProspectDocuments('UnemploymentReport');
    },
    workersCompLossReport() {
      return this.filterProspectDocuments('WorkersCompLossReport');
    },
    peoChoice: {
      get() {
        return this.$store.state.prospectPacket.flags.workingWithPEO;
      },
      set(value) {
        this.$store.commit('updateProspectPEOFlag', value);
      },
    },
    peoName: {
      get() {
        return this.$store.state.prospectPacket.peo.name;
      },
      set(value) {
        this.$store.commit('updatePEOCompanyName', value);
      },
    },
    peoDate: {
      get() {
        return this.$store.state.prospectPacket.peo.effectiveDate;
      },
      set(value) {
        this.$store.commit('updatePEODate', value);
      },
    },
    hasBenefitPacket: {
      get() {
        return this.$store.state.prospectPacket.flags.hasBenefitPacket;
      },
      set(value) {
        this.$store.commit('UpdateHasBenefitPacket', value);
      },
    },
  },
  methods: {
    showBenefitsTutorial() {
      if (this.$store.state.showHints) {
        this.$store.commit('updateShowBenefitsTutorial', true);
      }
    },
    filterProspectDocuments(categoryKey) {
      const { documents } = this.$store.state.prospectPacket;
      const document = documents.filter((x) => x.category === categoryKey);
      if (document === undefined) {
        return '';
      }
      return document;
    },
    setWorkersCompensation() {
      this.categoryTitle = 'Workers Compensation';
      this.categoryDescription = 'Delete and upload files.';
      this.categoryKey = 'WorkersCompensation';
      this.uploadDialog = true;
    },
    setWorkersCompensationPolicyInvoice() {
      this.categoryTitle = 'Workers Compensation Policy Invoice';
      this.categoryDescription = 'Delete and upload files.';
      this.categoryKey = 'WorkersCompensationPolicyInvoice';
      this.uploadDialog = true;
    },
    setPayrollRegister() {
      this.categoryTitle = 'Payroll Register';
      this.categoryDescription = 'Delete and upload files.';
      this.categoryKey = 'PayrollRegister';
      this.uploadDialog = true;
    },
    setUnemploymentReport() {
      this.categoryTitle = 'Unemployment Report';
      this.categoryDescription = 'Delete and upload files.';
      this.categoryKey = 'UnemploymentReport';
      this.uploadDialog = true;
    },
    setWorkersCompLossReport() {
      this.categoryTitle = 'Workers Compensation Loss Report';
      this.categoryDescription = 'Delete and upload files.';
      this.categoryKey = 'WorkersCompLossReport';
      this.uploadDialog = true;
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
